export default __webpack_public_path__ + "static/media/golang.27745085.svg";